import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import {
  BadGateway,
  BadRequestError,
  Forbidden,
  NotFound,
  UnexpectedError,
} from 'domain/errors';
import { LoginAuth } from 'domain/usecases/auth/remote';
import 'infra/global/variables';

export class RemoteLoginAuth implements LoginAuth {
  private readonly url: string;

  private readonly httpClient: HttpClient<LoginAuth.Model>;

  constructor(url: string, httClient: HttpClient<LoginAuth.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  login = async (params: LoginAuth.Params): Promise<LoginAuth.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError(httpResponse.body);
      case HttpStatusCode.notFound:
        throw new NotFound(httpResponse.body);
      case HttpStatusCode.unauthorized:
        throw new Forbidden(httpResponse.body);
      case HttpStatusCode.badGateway:
        throw new BadGateway(httpResponse.body);
      default:
        throw new UnexpectedError(httpResponse.body);
    }
  };
}
